import React from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { Link, useLocation } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import { SidebarItemType } from 'utils/types';
import './styles.scss';
import { ReactComponent as HomeIcon } from 'assets/icons/home-icon.svg';
import { ReactComponent as DiscountIcon } from 'assets/icons/discount-icon.svg';
import { ReactComponent as PushNotificationsIcon } from 'assets/icons/push-notifications-icon.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash-icon.svg';
import { ReactComponent as EmailIcon } from 'assets/icons/email-icon.svg';
import { ReactComponent as ExploreIcon } from 'assets/icons/explore-icon.svg';
import foodcourtLogo from 'assets/images/logo.png';

const Sidebar = () => {
  const { setShowMobileSidebar } = useDashboardContext();
  const { pathname } = useLocation();

  const SidebarMenu: SidebarItemType[] = [
    {
      name: 'Manage homepage',
      icon: <HomeIcon />,
      route: ROUTE_KEYS.HOME
    },
    {
      name: 'Deals & Discount',
      icon: <DiscountIcon />,
      route: ROUTE_KEYS.DEALS_AND_DISCOUNTS
    },
    {
      name: 'Push notifications',
      icon: <PushNotificationsIcon />,
      route: ROUTE_KEYS.PUSH_NOTIFICATIONS
    },
    {
      name: 'Emails',
      icon: <EmailIcon />,
      route: ROUTE_KEYS.EMAILS
    },
    {
      name: 'Explore',
      icon: <ExploreIcon />,
      route: ROUTE_KEYS.EXPLORE,
      underline: true
    },
    {
      name: 'Trash',
      icon: <TrashIcon />,
      route: ROUTE_KEYS.TRASH
    }
  ];

  const isLinkActive = (baseRoute: string) => {
    return pathname.startsWith(baseRoute);
  };

  return (
    <div className='sidebar'>
      <div className='max-lg:hidden sidebar_top'>
        <img src={foodcourtLogo} alt='' className='' />
      </div>

      <div className='sidebar_bottom'>
        {SidebarMenu.map(({ name, icon, route, underline }, index) => (
          <div key={index}>
            <Link
              to={route}
              onClick={() => setShowMobileSidebar(false)}
              className={`sidebar_bottom_item ${isLinkActive(route) ? 'active' : 'inactive'}`}>
              <div className='icon'>{icon}</div>
              <p className='text-gray-6 font-medium text-base'>{name}</p>
            </Link>
            {underline && <hr className='border-[#DDDEDF] border-opacity-50 mb-4' />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
